export default function Terms() {
  return (
    <div className="bg-white" data-testid="terms-of-service-page">
      <div className="max-w-3xl mx-auto px-6 py-14">
        <h1 className="text-3xl font-bold text-[#3C4048] mb-2" style={{ fontFamily: "Montserrat", fontWeight: 800 }}>
          Terms of Service
        </h1>
        <p className="text-[#7A9090] text-sm mb-10">Last updated: 26 August 2026</p>

        <div className="space-y-8 text-[#3C4048] text-sm leading-relaxed [&_h2]:text-lg [&_h2]:font-bold [&_h2]:mb-3 [&_h2]:mt-0 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-[#3A7A8C] [&_a]:font-semibold [&_a]:underline" style={{ fontFamily: "Montserrat" }}>
          <section>
            <h2>1. Agreement to terms</h2>
            <p>
              By accessing or using Post Your Content ("PYC", "we", "us", "our"), you agree to these
              Terms of Service. PYC is currently offered on an invite-only, personally onboarded basis —
              there is no public self-service sign-up, and accounts are provisioned by us after a
              demo/onboarding conversation.
            </p>
            <p>Questions about these terms: <a href="mailto:hello@postyourcontent.com">hello@postyourcontent.com</a>.</p>
          </section>

          <section>
            <h2>2. The service</h2>
            <p>
              PYC helps you plan, draft (including with AI assistance from our "Shee" Creative Director),
              review, approve and publish social media content to platforms you connect (e.g. Facebook,
              Instagram, LinkedIn, TikTok, YouTube). We are not affiliated with those platforms and are not
              responsible for their availability, policies or API changes.
            </p>
          </section>

          <section>
            <h2>3. AI-generated content</h2>
            <p>
              Some content (captions, images, video, voiceovers) may be generated with AI. AI output can be
              inaccurate or require editing — that is precisely why every piece of content, AI-made or not,
              must be reviewed and approved by an authorized human on your team before it publishes. You are
              responsible for reviewing and approving anything before it goes live under your accounts.
            </p>
          </section>

          <section>
            <h2>4. Your account & connected platforms</h2>
            <ul>
              <li>You're responsible for keeping your login credentials and connected-account tokens secure.</li>
              <li>You're responsible for having the rights to publish any content, brand assets or media you upload.</li>
              <li>You must comply with each connected platform's own terms of service (Meta, LinkedIn, TikTok, YouTube, etc.).</li>
            </ul>
          </section>

          <section>
            <h2>5. Acceptable use</h2>
            <p>
              Don't use PYC to publish unlawful, deceptive, or platform-policy-violating content, to attempt
              to bypass the Approval Queue's review requirement, or to access another workspace's data
              without authorization.
            </p>
          </section>

          <section>
            <h2>6. Availability & changes</h2>
            <p>
              We aim for reliable uptime but don't guarantee uninterrupted service — AI providers and social
              platforms we integrate with can also have their own outages or rate limits outside our control.
              We may update features or these terms over time; material changes will be communicated to your
              workspace admin.
            </p>
          </section>

          <section>
            <h2>7. Limitation of liability</h2>
            <p>
              PYC is provided "as is." To the fullest extent permitted by law, we are not liable for indirect,
              incidental, or consequential damages arising from use of the service, including content
              published after your team's approval.
            </p>
          </section>

          <section>
            <h2>8. Termination</h2>
            <p>
              Either party may end the arrangement at any time; contact us to close your workspace and
              request deletion of your data, subject to our <a href="/privacy">Privacy Policy</a>.
            </p>
          </section>

          <section>
            <h2>9. Contact</h2>
            <p>
              Post Your Content — <a href="mailto:hello@postyourcontent.com">hello@postyourcontent.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
